import React from 'react';
import clsx from 'clsx';

import { ReactComponent as EquifaxLogo } from 'images/equifax-logo.svg';
import { ReactComponent as EquifaxRedLogo } from 'images/equifax-red-logo.svg';

import styles from './PoweredByEquifax.module.scss';

export enum PoweredByEquifaxTone {
  OnLight = 'onLight',
  OnDark = 'onDark',
}

interface PoweredByEquifaxProps {
  tone?: PoweredByEquifaxTone;
  className?: string;
}

const PoweredByEquifax: React.FC<PoweredByEquifaxProps> = ({ tone = PoweredByEquifaxTone.OnLight, className }) => {
  const Logo = tone === PoweredByEquifaxTone.OnDark ? EquifaxLogo : EquifaxRedLogo;

  return (
    <div className={clsx(styles.poweredBy, styles[`poweredBy--${tone}`], className)}>
      <span className={styles.text}>Powered by</span>
      <Logo className={styles.logo} />
    </div>
  );
};

export default PoweredByEquifax;
